<template>
  <div class="footer_1">
    <Row type="flex" justify="center">
        <Col :xs="{ span: 12}" :lg="{ span: 6 }" :md="{ span: 6 }" :sm="{ span: 6 }" v-for='(v,i) in footerContent' :key='i'>
          <h3 class='title'>{{v[0].title}}</h3>
          <router-link :to='k.path' v-for=' (k,j) in v' :key='j' class='Footer-link' v-if='k.path'>
            {{k.title}}
          </router-link>
        </Col>
        <Col :xs="{ span: 12}" :lg="{ span: 6 }" :md="{ span: 6 }" :sm="{ span: 6 }">
          <div class="footer_3">
            <div class="phone">QQ: 398342328</div>
            <div class="phone">Tel: 15210550848</div>
            <img src="./weixin.png" alt="" style="width:100px;height:100px;padding-top:5px;">
          </div>
        </Col>
    </Row>
    <hr color='#d0d0d0' size='1'>
    <div class="footer_2">
      Copyright © www.dpihome.com, All Rights Reserved.<br /><span @click="go(url)" style="cursor:pointer">京ICP备14030620号-1</span>
  ｜ 浏览器需支持HTML5 建议IE9.0以上版本
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'Foot',
  data () {
    return {
      src: '@components/details_figure/components/wallpaper/5a7d0b8613cdf.jpg',
      // footer数据
      footerContent: [
        [
          { title: '解决方案' },
          { path: '/solution/2', title: '实验室信息化解决方案' },
          { path: '/solution/1', title: '多物理耦合计算解决方案' }
        ],
        [
          { title: '商务支持' },
          { path: '/', title: '业务支持' },
          { path: '/', title: '发票支持' }
        ],
        [
          { title: '关于我们' },
          { path: '/contact-info', title: '联系我们' },
          { path: '/contact-info', title: '工作机会' }
        ]
      ],
      url: 'http://beian.miit.gov.cn'
    }
  },
  methods: {
    go (e) {
        window.open(e, '_blank');
      }
  }
}
</script>
<style type="text/css" scoped>
  .footer_3 {
    font-size: 1.00rem;
  }
  a {
    text-decoration: none;
    color: #222;
    padding: 5px;
    display: block;
    font-size: 14px;
  }
  .Footer-link {
    font-size: 1.00rem;
    color: #FFFFFF;
  }
  .title {
    padding: 5px;
    font-size: 1.25rem;
  }
  .ivu-row-flex {
    padding: 30px 0px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #FFFFFF;
  }
  .footer_1 {
    background: #666666;
  }
  .footer_2 {
    height: 80px;
    background: #666666;
    color: #FFFFFF;
    text-align: center;
    font-size: 14px;
    padding-top: 20px;
  }
  @media screen and (max-width:3840px) {
    .ivu-row-flex {
      width: 1200px;
    }
  }
  @media screen and (max-width:1200px) {
    .ivu-row-flex {
      width: 992px;
    }
  }
  @media screen and (max-width:992px) {
    .ivu-row-flex {
      width: 768px;
    }
  }
  @media screen and (max-width:768px) {
    .ivu-row-flex {
      width: 100%;
    }
    .ivu-col {
      padding-bottom: 10px;
    }
  }
</style>
